import { type QueryClient, useMutation } from '@tanstack/react-query';

import { FILE_STORAGE_QUERY_KEY } from '#apps/client-web/features/file-storage/types/react-query';
import { type FileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';

export const useDeleteFileMutation = ({
  fileStorageService,
  queryClient,
}: {
  fileStorageService: FileStorageService;
  queryClient: QueryClient;
}) =>
  useMutation(
    {
      mutationKey: [FILE_STORAGE_QUERY_KEY],
      mutationFn: fileStorageService.delete.bind(fileStorageService),
    },
    queryClient,
  );
